function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LoungeOverlayTemplate = require('./lounge.template');
var jsonTree = require('json-tree-viewer');

/*
  General Interface for the Overlay that comes up when you click on a (game) "invite".
  There are several circumstances that affect what a user can do with the overlay, but because
  so much of the UI is identical it is better to have it all in one file instead of multiple
  files with the logic spread out across all the places where you might need to trigger the overlay.

  The basic purpose is to display the game details (results of game-selector/game-wizard) and allow a player to join/cance
*/
var LoungeOverlay = /*#__PURE__*/function () {
  function LoungeOverlay(app, mod, invite) {
    var _this = this;
    _classCallCheck(this, LoungeOverlay);
    this.app = app;
    this.mod = mod;
    this.invite = invite;
    this.game_id = null;
    this.overlay = new SaitoOverlay(app, mod, false, true); //No close button, auto-delete overlay

    app.connection.on('relay-is-online', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(pkey) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (_this.invite && pkey == _this.invite.originator) {
                if (document.getElementById("invite-user-".concat(pkey))) {
                  document.getElementById("invite-user-".concat(pkey)).classList.add('online');
                }
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('relay-is-busy', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(pkey) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (_this.invite && pkey == _this.invite.originator) {
                if (document.getElementById("invite-user-".concat(pkey))) {
                  document.getElementById("invite-user-".concat(pkey)).classList.add('online');
                  document.getElementById("invite-user-".concat(pkey)).classList.add('busy');
                }
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    app.connection.on('arcade-close-game', function (game_id) {
      if (game_id == (_this === null || _this === void 0 ? void 0 : _this.game_id)) {
        _this.overlay.close();
        if (_this.mod.browser_active && _this.mod.ui) {
          _this.mod.ui.render();
        }
      }
    });
  }
  return _createClass(LoungeOverlay, [{
    key: "render",
    value: function render() {
      if (this.game_id != null && this.invite == null) {
        this._renderGameIdMode();
        return;
      }
      var game_mod = this.app.modules.returnModuleBySlug(this.invite.game_slug);
      if (this.mod.sudo) {
        this.overlay.show("<div class=\"arcade-lounge debug_overlay\"><button class=\"saito-button-primary\" id=\"clear-invite\">Delete</button></div>");
        if (!this.mod.styles.includes('/saito/lib/jsonTree/jsonTree.css')) {
          this.mod.styles.push('/saito/lib/jsonTree/jsonTree.css');
          this.mod.attachStyleSheets();
        }
        var el = document.querySelector('.arcade-lounge');
        try {
          var optjson = JSON.parse(JSON.stringify(this.invite, function (key, value) {
            return key == 'game_mod' ? 'game_mod' : value;
          }));
          var tree = jsonTree.create(optjson, el);
        } catch (err) {
          console.error('ARCADE: [joinGame] error creating jsonTree: ', err);
        }
      } else {
        this.overlay.show(LoungeOverlayTemplate(this.app, this.mod, this.invite));
      }
      this.overlay.setBackground(game_mod.respondTo('arcade-games').image);
      this.attachEvents();
      this.app.connection.emit('add-league-identifier-to-dom');
    }
  }, {
    key: "_renderGameIdMode",
    value: function _renderGameIdMode() {
      var _game$tx, _game_mod, _game_mod$returnSlug, _game_mod2, _game_mod2$respondTo, _game_mod$returnName, _game_mod3;
      var game = this.mod.returnGame(this.game_id);
      var state = game === null || game === void 0 ? void 0 : game.state;
      var txGame = game === null || game === void 0 || (_game$tx = game.tx) === null || _game$tx === void 0 || (_game$tx = _game$tx.msg) === null || _game$tx === void 0 ? void 0 : _game$tx.game;
      var stateModule = state === null || state === void 0 ? void 0 : state.module;
      // Resolve game_mod: from game tx/state, or from observer_game_module_slug when metadata is missing
      var game_mod = this.app.modules.returnModule(txGame) || this.app.modules.returnModuleBySlug(stateModule || txGame || 'arcade') || this.app.modules.returnModule(stateModule);
      if (!game_mod && this.observer_game_module_slug) {
        game_mod = this.app.modules.returnModuleBySlug(this.observer_game_module_slug);
      }
      var slug = ((_game_mod = game_mod) === null || _game_mod === void 0 || (_game_mod$returnSlug = _game_mod.returnSlug) === null || _game_mod$returnSlug === void 0 ? void 0 : _game_mod$returnSlug.call(_game_mod)) || stateModule || txGame || this.observer_game_module_slug || 'arcade';
      var image = ((_game_mod2 = game_mod) === null || _game_mod2 === void 0 || (_game_mod2$respondTo = _game_mod2.respondTo) === null || _game_mod2$respondTo === void 0 || (_game_mod2$respondTo = _game_mod2$respondTo.call(_game_mod2, 'arcade-games')) === null || _game_mod2$respondTo === void 0 ? void 0 : _game_mod2$respondTo.image) || '';
      var gameName = game_mod && (((_game_mod$returnName = (_game_mod3 = game_mod).returnName) === null || _game_mod$returnName === void 0 ? void 0 : _game_mod$returnName.call(_game_mod3)) || game_mod.name) || txGame || slug;
      var derivedState;
      if (state && state.initializing === 1) {
        derivedState = 'INITIALIZING';
      } else if (state && state.initializing === 0 && !state.over) {
        derivedState = 'READY';
      } else if (state && state.over === 1) {
        derivedState = 'COMPLETED';
      } else {
        derivedState = 'INITIALIZING';
      }
      var stateLabel, bodyHtml, controlsHtml;
      var headerImageStyle = image ? " style=\"background-image: url('".concat(image, "')\"") : '';

      //
      // No local metadata for this game_id – show observer overlay.
      // If archive has game data: enable Watch Game. Otherwise: show message and disable button.
      //
      if (!game) {
        stateLabel = 'Observer Mode';
        var hasArchive = this.observer_has_archive_data === true;
        var message = hasArchive ? 'You can watch this game.' : 'This server does not yet have game data for this match.';
        bodyHtml = "\n\t  <div class=\"arcade-lounge-section arcade-lounge-section-game-id-message\">\n\t\t  <div class=\"arcade-lounge-message arcade-lounge-message-game-id\">".concat(message, "</div>\n\t  </div>");
        controlsHtml = hasArchive ? "<button id=\"arcade-game-controls-watch-game\" class=\"fat saito-button-primary\">Watch Game</button>" : "<button id=\"arcade-game-controls-watch-game\" class=\"fat saito-button-primary\" disabled>Watch Game</button>";
      } else if (derivedState === 'INITIALIZING') {
        stateLabel = 'Initializing Game';
        bodyHtml = "\n\t  <div class=\"arcade-lounge-section\">\n\t\t  <div id=\"game-loader-spinner\" class=\"arcade-lounge-loader game-loader-spinner\"></div>\n\t\t  <div class=\"arcade-lounge-message\">Setting up your game...</div>\n\t  </div>";
        controlsHtml = '';
      } else if (derivedState === 'READY') {
        stateLabel = 'Game Ready';
        bodyHtml = this._buildReadyBody(game, state, game_mod);
        controlsHtml = "\n\t  <div id=\"arcade-game-controls-start-game\" class=\"fat saito-button-primary\">Start Game</div>\n\t  <div id=\"arcade-game-controls-close-game\" class=\"fat saito-button-secondary\">Cancel</div>";
      } else {
        stateLabel = 'Game completed';
        bodyHtml = '';
        controlsHtml = "\n\t  <div id=\"arcade-game-controls-continue-game\" class=\"fat saito-button-primary\">View game</div>";
      }

      // Unified layout: same header (thumbnail + title + subtitle), body, chat, controls for all states
      var html = "\n  <div class=\"arcade-lounge\">\n  <div class=\"arcade-lounge-header\">\n\t  <div class=\"arcade-lounge-header-image\"".concat(headerImageStyle, "></div>\n\t  <div class=\"arcade-lounge-header-title\">").concat(gameName, "</div>\n\t  <div class=\"arcade-lounge-header-desc\">").concat(stateLabel, "</div>\n  </div>\n  <div class=\"arcade-lounge-body\">\n\t  ").concat(bodyHtml, "\n  </div>\n  <div class=\"arcade-lounge-chat\"></div>\n  <div class=\"arcade-lounge-controls\">").concat(controlsHtml, "\n  </div>\n</div>");
      this.overlay.show(html);
      this.overlay.setBackground(image);
      this.attachEvents();
      this.app.connection.emit('add-league-identifier-to-dom');
    }
  }, {
    key: "_buildReadyBody",
    value: function _buildReadyBody(record, state, game_mod) {
      var _record$tx, _record$tx2;
      var players = (state === null || state === void 0 ? void 0 : state.players) || (record === null || record === void 0 || (_record$tx = record.tx) === null || _record$tx === void 0 || (_record$tx = _record$tx.msg) === null || _record$tx === void 0 ? void 0 : _record$tx.players) || [];
      var options = (state === null || state === void 0 ? void 0 : state.options) || (record === null || record === void 0 || (_record$tx2 = record.tx) === null || _record$tx2 === void 0 || (_record$tx2 = _record$tx2.msg) === null || _record$tx2 === void 0 ? void 0 : _record$tx2.options) || {};
      var optsHtml = '';
      if (game_mod && typeof game_mod.returnShortGameOptionsArray === 'function') {
        var sgoa = game_mod.returnShortGameOptionsArray(options);
        for (var key in sgoa) {
          if (sgoa[key] != null) {
            optsHtml += "<div class=\"saito-table-row\"><div class=\"arcade-lounge-key\">".concat(String(key).replace(/_/g, ' '), "</div><div class=\"arcade-lounge-value\">").concat(sgoa[key], "</div></div>");
          }
        }
      }
      var playersHtml = '';
      for (var i = 0; i < players.length; i++) {
        var pkey = players[i];
        playersHtml += "\n\t\t  <div class=\"arcade-lounge-playerbox saito-table-row\" id=\"invite-user-".concat(pkey, "\">\n\t\t    <div class=\"saito-identicon-box\"><img class=\"saito-identicon\" src=\"").concat(this.app.keychain.returnIdenticon(pkey), "\"></div>\n\t\t    ").concat(this.app.browser.returnAddressHTML(pkey), "\n\t\t    <div class=\"online-status-indicator\"></div>\n\t\t  </div>");
      }
      return "\n\t  <div class=\"arcade-lounge-section hide-scrollbar\">\n\t    <div class=\"arcade-lounge-players\">".concat(playersHtml, "\n\t    </div>\n\t    <div class=\"saito-table\"><div class=\"saito-table-body\">").concat(optsHtml, "</div></div>\n\t  </div>");
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var startBtn = document.getElementById('arcade-game-controls-start-game');
      if (startBtn && this.game_id != null) {
        startBtn.onclick = function (e) {
          var _game$tx2, _game$state, _mod$returnSlug, _this2$app$modules$re;
          var game = _this2.mod.returnGame(_this2.game_id);
          var gameName = (game === null || game === void 0 || (_game$tx2 = game.tx) === null || _game$tx2 === void 0 || (_game$tx2 = _game$tx2.msg) === null || _game$tx2 === void 0 ? void 0 : _game$tx2.game) || (game === null || game === void 0 || (_game$state = game.state) === null || _game$state === void 0 ? void 0 : _game$state.module);
          var mod = gameName ? _this2.app.modules.returnModule(gameName) : null;
          var slug = (mod === null || mod === void 0 || (_mod$returnSlug = mod.returnSlug) === null || _mod$returnSlug === void 0 ? void 0 : _mod$returnSlug.call(mod)) || (mod === null || mod === void 0 ? void 0 : mod.slug) || gameName || 'arcade';
          var am = ((_this2$app$modules$re = _this2.app.modules.returnActiveModule()) === null || _this2$app$modules$re === void 0 ? void 0 : _this2$app$modules$re.returnName()) || 'Arcade';
          _this2.app.options.homeModule = am;
          _this2.app.storage.saveOptions();
          navigateWindow("/".concat(slug), 200);
        };
      }
      if (document.getElementById('arcade-game-controls-join-game')) {
        //This is a joinable game
        this.app.connection.emit('relay-send-message', {
          recipient: [this.invite.originator],
          request: 'ping',
          data: {}
        });
        document.getElementById('arcade-game-controls-join-game').onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var _this2$invite$options;
            var open_invites, c, _iterator, _step, game_id, game_mod, _t;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.p = _context3.n) {
                case 0:
                  open_invites = _this2.mod.returnOpenInvites();
                  if (!(open_invites.length > 0)) {
                    _context3.n = 2;
                    break;
                  }
                  _context3.n = 1;
                  return sconfirm('You have an open invite. Would you like to close it to join this game?');
                case 1:
                  c = _context3.v;
                  if (c) {
                    _iterator = _createForOfIteratorHelper(open_invites);
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        game_id = _step.value;
                        _this2.mod.sendCancelTransaction(game_id);
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                case 2:
                  _this2.overlay.remove();
                  if (!(_this2.invite.options.crypto && (parseFloat(_this2.invite.options.stake) > 0 || parseFloat((_this2$invite$options = _this2.invite.options.stake) === null || _this2$invite$options === void 0 ? void 0 : _this2$invite$options.min) >= 0))) {
                    _context3.n = 6;
                    break;
                  }
                  _context3.p = 3;
                  game_mod = _this2.app.modules.returnModuleBySlug(_this2.invite.game_slug);
                  _this2.app.connection.emit('accept-game-stake', {
                    game_mod: game_mod,
                    ticker: _this2.invite.options.crypto,
                    stake: _this2.invite.options.stake,
                    accept_callback: function accept_callback() {
                      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                      var update_options = input !== null && _typeof(_this2.invite.options.stake) == 'object' ? 'stake' : '';
                      if (update_options) {
                        _this2.invite.options.stake[_this2.mod.publicKey] = input;
                      }
                      _this2.mod.sendJoinTransaction(_this2.invite, update_options);
                    }
                  });
                  _context3.n = 5;
                  break;
                case 4:
                  _context3.p = 4;
                  _t = _context3.v;
                  console.error('ARCADE [joinGame] ERROR checking crypto: ', _t);
                  return _context3.a(2, false);
                case 5:
                  _context3.n = 7;
                  break;
                case 6:
                  _this2.mod.sendJoinTransaction(_this2.invite);
                case 7:
                  return _context3.a(2);
              }
            }, _callee3, null, [[3, 4]]);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('arcade-game-controls-continue-game')) {
        document.getElementById('arcade-game-controls-continue-game').onclick = function (e) {
          var slug, gameId, name;
          if (_this2.invite) {
            var _this2$invite$game_mo;
            slug = _this2.invite.game_slug;
            gameId = _this2.invite.game_id;
            name = (_this2$invite$game_mo = _this2.invite.game_mod) === null || _this2$invite$game_mo === void 0 ? void 0 : _this2$invite$game_mo.name;
          } else if (_this2.game_id != null) {
            var _game$tx3, _game$state2, _mod$returnSlug2, _mod$returnName;
            var game = _this2.mod.returnGame(_this2.game_id);
            var gameName = (game === null || game === void 0 || (_game$tx3 = game.tx) === null || _game$tx3 === void 0 || (_game$tx3 = _game$tx3.msg) === null || _game$tx3 === void 0 ? void 0 : _game$tx3.game) || (game === null || game === void 0 || (_game$state2 = game.state) === null || _game$state2 === void 0 ? void 0 : _game$state2.module);
            var mod = gameName ? _this2.app.modules.returnModule(gameName) : null;
            slug = (mod === null || mod === void 0 || (_mod$returnSlug2 = mod.returnSlug) === null || _mod$returnSlug2 === void 0 ? void 0 : _mod$returnSlug2.call(mod)) || (mod === null || mod === void 0 ? void 0 : mod.slug) || gameName || 'arcade';
            gameId = _this2.game_id;
            name = (mod === null || mod === void 0 || (_mod$returnName = mod.returnName) === null || _mod$returnName === void 0 ? void 0 : _mod$returnName.call(mod)) || (mod === null || mod === void 0 ? void 0 : mod.name);
          }
          if (slug != null && gameId != null) {
            navigateWindow("/".concat(slug, "/#gid=").concat(encodeURIComponent(gameId)));
          }
        };
      }
      if (document.getElementById('arcade-game-controls-close-game')) {
        document.getElementById('arcade-game-controls-close-game').onclick = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var c, _this2$invite$game_mo2;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  if (!_this2.invite) {
                    _context4.n = 2;
                    break;
                  }
                  _this2.overlay.remove();
                  _context4.n = 1;
                  return sconfirm('Are you sure you want to end the game?');
                case 1:
                  c = _context4.v;
                  if (c) {
                    _this2.app.connection.emit('arcade-stop-game', (_this2$invite$game_mo2 = _this2.invite.game_mod) === null || _this2$invite$game_mo2 === void 0 ? void 0 : _this2$invite$game_mo2.name, _this2.invite.game_id, 'cancellation');
                  }
                  _context4.n = 3;
                  break;
                case 2:
                  if (_this2.game_id != null) {
                    _this2.overlay.remove();
                  }
                case 3:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }();
      }

      //
      // This is a little complicated because an initialized game will persist in the
      // app.options and keep getting added back to the arcade list because it didn't
      // reach a gameover. So, we send a game over request through the game, but if the opponent
      // isn't online it doesn't process, so we need an additional fallback just to make
      // sure we aren't annoyed by being unable to close a game.
      // Of course, forfeiting a game might hurt one's leaderboard standings, but the leaderboard
      // and game engine have checks to prevent that in most cases where a game breaks early on
      //
      if (document.getElementById('arcade-game-controls-forfeit-game')) {
        document.getElementById('arcade-game-controls-forfeit-game').onclick = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            var c, _this2$invite$game_mo3;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _this2.overlay.remove();
                  _context5.n = 1;
                  return sconfirm('Are you sure you want to end the game and take a loss?');
                case 1:
                  c = _context5.v;
                  if (c) {
                    _this2.app.connection.emit('arcade-stop-game', (_this2$invite$game_mo3 = _this2.invite.game_mod) === null || _this2$invite$game_mo3 === void 0 ? void 0 : _this2$invite$game_mo3.name, _this2.invite.game_id, 'forfeit');
                  }
                case 2:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x5) {
            return _ref5.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('arcade-game-controls-cancel-join')) {
        document.getElementById('arcade-game-controls-cancel-join').onclick = function (e) {
          _this2.mod.sendCancelTransaction(_this2.invite.game_id);
          _this2.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-invite-join')) {
        document.getElementById('arcade-game-controls-invite-join').onclick = function (e) {
          _this2.mod.showShareLink(_this2.invite.game_id);
        };
      }
      if (document.getElementById('arcade-game-controls-watch-game')) {
        document.getElementById('arcade-game-controls-watch-game').onclick = function (e) {
          var _this2$invite$game_id, _this2$invite;
          var gid = (_this2$invite$game_id = (_this2$invite = _this2.invite) === null || _this2$invite === void 0 ? void 0 : _this2$invite.game_id) !== null && _this2$invite$game_id !== void 0 ? _this2$invite$game_id : _this2.game_id;
          if (!gid) return;
          _this2.app.connection.emit('league-overlay-remove-request');
          _this2.mod.observeGame(gid, true, _this2.observer_game_module_slug || undefined);
          _this2.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-review-game')) {
        document.getElementById('arcade-game-controls-review-game').onclick = function (e) {
          _this2.app.connection.emit('league-overlay-remove-request');
          _this2.mod.observeGame(_this2.invite.game_id);
          _this2.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-clear-game')) {
        document.getElementById('arcade-game-controls-clear-game').onclick = function (e) {
          _this2.mod.removeGameFromWallet(_this2.invite.game_id);
          _this2.overlay.remove();
        };
      }

      /*Array.from(document.querySelectorAll('.available_slot')).forEach((emptySlot) => {
      	emptySlot.onclick = () => {
      		this.mod.showShareLink(this.invite.game_id, false);
      		this.overlay.remove();
      	};
      });*/

      if (document.getElementById('clear-invite')) {
        document.getElementById('clear-invite').onclick = function (e) {
          _this2.app.network.sendRequestAsTransaction('arcade clear invite', {
            game_id: _this2.invite.game_id
          }, function () {
            window.location.reload();
          });
        };
      }
    }
  }]);
}();
module.exports = LoungeOverlay;